/* 展示格式化。 */

const nf = (d) => ({ minimumFractionDigits: d, maximumFractionDigits: d })

/** 金额。负数带负号在 $ 之前，避免出现 "$-123" 这种别扭写法。 */
export function usd(value, d = 2) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '—'
  const v = Number(value)
  return (v < 0 ? '-$' : '$') + Math.abs(v).toLocaleString('en-US', nf(d))
}

/**
 * 带正负号的金额。
 *
 * 注意别用 replace('-','') 剥符号 —— 那会把亏损显示成盈利，
 * 在风控面板上是能直接误导操作决策的错误（本项目踩过）。
 */
export function signed(value, d = 2) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '—'
  const v = Number(value)
  return (v >= 0 ? '+' : '-') + usd(Math.abs(v), d)
}

export function pct(value, d = 2) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '—'
  const v = Number(value)
  return (v >= 0 ? '+' : '') + (v * 100).toFixed(d) + '%'
}

export function qty(value, d = 6) {
  if (value === null || value === undefined) return '—'
  return Number(value).toLocaleString('en-US', { maximumFractionDigits: d })
}

export const pnlClass = (v) =>
  v === null || v === undefined ? 'muted' : Number(v) >= 0 ? 'positive' : 'negative'

export function timeOf(ms) {
  if (!ms) return '—'
  return new Date(Number(ms)).toLocaleTimeString('zh-CN', { hour12: false })
}

export function dateTimeOf(ms) {
  if (!ms) return '—'
  return new Date(Number(ms)).toLocaleString('zh-CN', { hour12: false })
}

/** 后端一律用字符串传 Decimal，避免 float 误差；这里统一转数字，空值转 null。 */
export const num = (v) => (v === null || v === undefined || v === '' ? null : Number(v))

/**
 * 把"距上次行情更新过了多久"说成人话。
 *
 * 原先叫「行情年龄」并直接显示毫秒数（如 6467 ms）—— 那是内部字段
 * market_data_age_ms 的字面翻译，只有开发看得懂：普通用户既不知道
 * 「年龄」指什么，也读不出五位毫秒数的量级。
 *
 * @param ms   距上次更新的毫秒数
 * @param stale 判定为"已停止更新"的阈值
 */
export function freshnessText(ms, stale = Infinity) {
  if (ms === null || ms === undefined || ms > 1e12) return '暂无数据'
  if (ms >= stale) return `已 ${Math.round(ms / 1000)} 秒未更新`
  if (ms < 2000) return '刚刚更新'
  if (ms < 60000) return `${(ms / 1000).toFixed(1)} 秒前更新`
  return `${Math.floor(ms / 60000)} 分钟前更新`
}
